export default __webpack_public_path__ + "static/media/viewBTN.363d0d05.gif";